import { InputAdornment } from '@material-ui/core'
import React, { FC, ReactElement, Ref, useRef, useState } from 'react'
import { ReactState } from '../../Contexts'
import { IconName } from '../Icon'
import IconButton, { IconButtonType } from '../IconButton'
import PopperBubble from '../PopperBubble'

type Props = {
    iconName: IconName
    onClick?: (e?: React.MouseEvent<Element, MouseEvent>) => void
    popperText?: string
}

/**
 * Add an icon button to an input as an end adornment.
 *
 * @param iconName - Name of the icon for the button.
 * @param onClick - A click event handler.
 * @param popperText - Text to put into a popper that appears on hover.
 */
export const InputAdornmentButton: FC<Props> = ({ iconName, onClick, popperText }: Props): ReactElement => {
    const [popperOpen, setPopperOpen]: ReactState<boolean> = useState<boolean>(false)

    const iconRef: Ref<HTMLElement> = useRef(null)

    return (
        <InputAdornment position='end' className='input-toggle'>
            <IconButton
                iconName={iconName}
                type={IconButtonType.BUTTON}
                onClick={onClick}
                buttonType='button'
                ref={iconRef}
                onMouseOver={(): void => setPopperOpen(true)}
                onMouseOut={(): void => setPopperOpen(false)}
            />

            {popperText ? (
                <PopperBubble
                    className='ihc-popper'
                    content={<>{popperText}</>}
                    anchorEl={iconRef.current}
                    placement='top'
                    open={popperOpen}
                    infoMode
                />
            ) : (
                <></>
            )}
        </InputAdornment>
    )
}
